import {TelefoneCliente} from './telefone-cliente';
import {EnderecoCliente} from './endereco-cliente';
import {AreaCliente} from './area-cliente';
import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class Cliente implements Construtor<Cliente> {

  public idCliente: number;
  public cnpj: string;
  public razaoSocial: string;
  public nomeFantasia: string;
  public responsavel: string;
  public site: string;
  public cargo: string;
  public email: string;
  public logo: string;
  public enderecosCliente: EnderecoCliente[];
  public telefonesCliente: TelefoneCliente[];
  public areasCliente: AreaCliente[];

  constructor(object?: any) {

    this.enderecosCliente = new Array<EnderecoCliente>();
    this.telefonesCliente = new Array<TelefoneCliente>();
    this.areasCliente = new Array<AreaCliente>();

    if (object !== undefined) {

      if (object instanceof Cliente) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;
  }

  get obterIdCliente(): number {
    return this.idCliente;
  }

  set IdCliente(idCliente: any) {
    this.idCliente = idCliente;
  }

  get obterCnpj(): string {
    return this.cnpj.slice(0);
  }

  set Cnpj(cnpj: any) {
    this.cnpj = StringValidacao.copiarStringValida(cnpj);
  }

  get obterRazaoSocial(): string {
    return this.razaoSocial.slice(0);
  }

  set RazaoSocial(razaoSocial: any) {
    this.razaoSocial = StringValidacao.copiarStringValida(razaoSocial);
  }

  get obterNomeFantasia(): string {
    return this.nomeFantasia.slice(0);
  }

  set NomeFantasia(nomeFantasia: any) {
    this.nomeFantasia = StringValidacao.copiarStringValida(nomeFantasia);
  }

  get obterResponsavel(): string {
    return this.responsavel.slice(0);
  }

  set Responsavel(responsavel: any) {
    this.responsavel = StringValidacao.copiarStringValida(responsavel);
  }

  get obterSite(): string {
    return this.site.slice(0);
  }

  set Site(site: any) {
    this.site = StringValidacao.copiarStringValida(site);
  }

  get obterCargo(): string {
    return this.cargo.slice(0);
  }

  set Cargo(cargo: any) {
    this.cargo = StringValidacao.copiarStringValida(cargo);
  }

  get obterEmail(): string {
    return this.email;
  }

  set Email(email: any) {
    this.email = StringValidacao.copiarStringValida(email);
  }

  get obterLogo(): string {
    return this.logo;
  }

  set Logo(logo: any) {
    this.logo = logo;
  }

  set insertEnderecoCliente(enderecoCliente: EnderecoCliente) {
    this.enderecosCliente.push(enderecoCliente);
  }

  set EnderecosCliente(enderecosCliente: any) {

    if (enderecosCliente !== undefined) {

      this.enderecosCliente = new Array<EnderecoCliente>();

      for (const enderecoCliente of enderecosCliente) {
        this.insertEnderecoCliente = new EnderecoCliente(enderecoCliente);
      }
    }

  }

  set insertTelefoneCliente(telefoneCliente: TelefoneCliente) {
    this.telefonesCliente.push(telefoneCliente);
  }

  set TelefonesCliente(telefonesCliente: any) {

    if (telefonesCliente !== undefined) {

      this.telefonesCliente = new Array<TelefoneCliente>();

      for (const telefoneCliente of telefonesCliente) {
        this.insertTelefoneCliente = new TelefoneCliente(telefoneCliente);
      }
    }

  }

  get obterTelefonesCliente(): TelefoneCliente[] {
    return this.telefonesCliente;
  }

  get obterEnderecosCliente(): EnderecoCliente[] {
    return this.enderecosCliente;
  }

  copyObject(cliente: Cliente): void {

    this.idCliente = cliente.obterIdCliente;
    this.cnpj = cliente.obterCnpj;
    this.razaoSocial = cliente.obterRazaoSocial;
    this.nomeFantasia = cliente.obterNomeFantasia;
    this.responsavel = cliente.obterResponsavel;
    this.site = cliente.obterSite;
    this.cargo = cliente.obterCargo;
    this.logo = cliente.logo;
    this.Email = cliente.email;
    this.EnderecosCliente = cliente.enderecosCliente;
    this.TelefonesCliente = cliente.telefonesCliente;
    this.areasCliente = cliente.areasCliente;
  }

  parseFromJson(cliente: any): void {

    this.IdCliente = cliente.idCliente;
    this.Cnpj = cliente.cnpj;
    this.RazaoSocial = cliente.razaoSocial;
    this.NomeFantasia = cliente.nomeFantasia;
    this.Responsavel = cliente.responsavel;
    this.Site = cliente.site;
    this.Cargo = cliente.cargo;
    this.Logo = cliente.logo;
    this.Email = cliente.email;
    this.EnderecosCliente = cliente.enderecosCliente;
    this.TelefonesCliente = cliente.telefonesCliente;
    this.areasCliente = cliente.areasCliente;

  }

  modeloCompleto(): boolean {
    return this.cnpj !== undefined &&
      this.razaoSocial !== undefined &&
      this.nomeFantasia !== undefined &&
      this.responsavel !== undefined &&
      this.site !== undefined &&
      this.cargo !== undefined &&
      this.email !== undefined;
  }

  getNewInstance(object?: any): Cliente {
    return new Cliente(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/cliente.ts